class dropHintJS {
    constructor() {
        this.form = document.querySelector('[data-dropahintform]');
        this.dropHintModal = document.querySelector('#ProductPopup-DropHint');
        this.formInputs = document.querySelectorAll('input, textarea');
        this.submitBtn = this.form.querySelector('[type="submit"]');
        this.requestHeader = {'revision': '2024-02-15', 'content-type': 'application/json'};
        this.subscribeListURL = "https://a.klaviyo.com/client/subscriptions/?company_id=HjgktP";
        this.subscribeEventURL = "https://a.klaviyo.com/client/events/?company_id=HjgktP";

        this.form.addEventListener('submit', this.onFormSubmit.bind(this));
        this.formInputs.forEach((input)=>{
            input.addEventListener('input', Utility.debounce((event) => {
                this.inputChange(event);
            }, 500).bind(this))
        });
    }

    /**
     * Trigger Form Submit event
     * Create drop a hint event for receiver
     * @param {*} event 
     * Reference: https://developers.klaviyo.com/en/reference/create_client_event
     */

    onFormSubmit(evt) {
        evt.preventDefault();
        this.form.classList.add('loading');
        
        let submitForm = true; 
        const hintFormData = new FormData(this.form);
        
        for (const [key, value] of hintFormData) {
            let trimmedValue = value.trim();
            if(key != 'message' && trimmedValue.length <= 0){
                this.form.querySelector(`#${key}`).classList.add('error');
                submitForm = false;
            }

            if(key == 'senderEmail' || key == 'recipientEmail'){
                const validateEmail = Utility.validateEmail(value);
                if(!validateEmail){
                    this.form.querySelector(`#${key}`).classList.add('error');
                    submitForm = false;
                }
            }
        }
        if(!submitForm) return;

        this.submitBtn.setAttribute('disabled', true);
    
        const eventData = {
            type: 'event',
            attributes: {
                properties: {
                    "$dah-name": hintFormData.get('recipientName'),
                    "$dah-sender_email": hintFormData.get('senderEmail'),
                    "$dah-recipient_email": hintFormData.get('recipientEmail'),
                    "$dah-sender_name": hintFormData.get('senderName'),
                    "$dah-note": hintFormData.get('message'),
                    "$dah-product-link": window.location.href,
                    "$dah-product-image": `https:${window.globalVariables.product.featured_image}`,
                    "$dah-product-title": window.globalVariables.product.title
                },
                metric: {data: {type: 'metric', attributes: {name: 'Drop A Hint submission received'}}},
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: hintFormData.get('recipientEmail')
                        }
                    }
                }
            }
        };

        fetch(this.subscribeEventURL, {
            method: "POST",
            headers: this.requestHeader,
            body: JSON.stringify({
                data: eventData
            })
        })
        .then(response => {
            if(response.status == 202){
                this.subscribeReceiver(hintFormData.get('recipientEmail'), hintFormData.get('senderEmail'));
            }else{
                this.submitBtn.removeAttribute('disabled');
                window.notificationEle.updateNotification('Something went wrong!', 'Try again after sometime.', {
                  type: 'error',
                  timeout: 5000
                });
            }
        })
        .catch(error => {
            this.submitBtn.removeAttribute('disabled');
            window.notificationEle.updateNotification('Something went wrong!', 'Try again after sometime.', {
                type: 'error',
                timeout: 5000
            });
            throw error;
        });
    }

    /**
     * Subscribe receiver to Drop A Hint list
     * Reference: https://developers.klaviyo.com/en/reference/create_client_subscription
     * 
    */
     subscribeReceiver(recipientEmail, senderEmail){
        const receiverData = {
            type: 'subscription',
            attributes: {
              custom_source: 'Drop A Hint custom form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: recipientEmail
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: 'TrspNX'}}}
        }
       
        fetch(this.subscribeListURL, {
            method: "POST",
            headers: this.requestHeader,
            body: JSON.stringify({
                data: receiverData
            })
        })
        .then(response => {
            
            this.form.querySelector('.sent-to-text').innerText = 'SENT TO';
            this.subscribeSender(senderEmail);
            setTimeout(() => {
                this.form.querySelector('.sent-to-text').innerText = this.form.querySelector('.sent-to-text').dataset.default;
                this.clearForm();
                this.form.classList.remove('loading');
            }, 3000);        
        })
        .catch(error => {
            this.submitBtn.removeAttribute('disabled');
            throw error;
        });
    }

    /**
     * Subscribe sender to Drop A Hint sender list
     * Reference: https://developers.klaviyo.com/en/reference/create_client_subscription
     * 
    */
    subscribeSender(senderEmail){
        const senderData = {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: senderEmail,
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: 'TaXnJr'}}}
        }
        fetch(this.subscribeListURL, {
            method: "POST",
            headers: this.requestHeader,
            body: JSON.stringify({
                data: senderData
            })
        })
        .then(response => {
            
        })
        .catch(error => console.error(error));
    }

    /**
     * Trigger input change event
     * @param {*} event 
    */
     inputChange(event){
        let targetInput = event.srcElement;
        const inputValue = targetInput.value.trim();
        targetInput.classList.remove('error');    

        if(targetInput.name == 'recipientName'){
            this.dropHintModal.querySelectorAll('.recipient-name').forEach((ele)=>{
                ele.innerText = inputValue;
            });
        }
        if(targetInput.name == 'senderName'){
            this.dropHintModal.querySelectorAll('.sender-name').forEach((ele)=>{
                ele.innerText = inputValue;
            });
        }
        if(targetInput.name == 'message'){
            this.dropHintModal.querySelector('.custom-message').innerText = inputValue;
            if(inputValue.length > 0){
                this.dropHintModal.querySelector('.pd-drop-message').classList.remove('d-none');
            }else{
                this.dropHintModal.querySelector('.pd-drop-message').classList.add('d-none');
            }
        }
    }

    /**
     * Clear form inputs after submission
     * 
    */
    clearForm(){
        this.submitBtn.removeAttribute('disabled');
        this.formInputs.forEach((input)=>{
            input.value = '';
        });
        this.dropHintModal.querySelectorAll('.sender-name, .recipient-name').forEach((ele)=>{
            ele.innerText = '';
        });

        this.dropHintModal.querySelectorAll('.sender-name').forEach((ele)=>{
            ele.innerText = '';
        });
        this.dropHintModal.querySelector('.custom-message').innerText = '';
        this.dropHintModal.querySelector('.pd-drop-message').classList.add('d-none');
    }
}

typeof dropHintJS !== 'undefined' && new dropHintJS();